import { onAuthStateChanged } from 'firebase/auth';
import axios from 'utils/axios';
import { auth } from '../../../firebase';
import { v4 as uuidv4 } from 'uuid';

/**
 * Permanently stops a simulation — unlike pause, it cannot be resumed.
 * Calling it on an already terminated or completed simulation is a no-op
 * (`alreadyTerminated: true`). Check `aiServiceStopTriggered` / `aiServiceError`.
 */
const terminateSimulation = (simulationId, callback, errorCallback) => {
  return async (dispatch) => {
    try {
      let unsubscribe = onAuthStateChanged(auth, async (user) => {
        const token = await user?.getIdToken();
        const reqId = uuidv4();
        try {
          const response = await axios.post(
            `/ads/admin/simulations/${simulationId}/terminate`,
            null,
            {
              params: {
                'request-id': reqId,
              },
              headers: {
                Authorization: `Bearer ${token}`,
              },
            },
          );
          if (response.status === 200) {
            if (typeof callback === 'function') callback(response?.data);
          } else {
            if (typeof errorCallback === 'function')
              errorCallback('Failed to terminate simulation');
          }
        } catch (e) {
          if (typeof errorCallback === 'function')
            errorCallback(
              e?.response?.data?.message || 'Failed to terminate simulation',
            );
        }
        unsubscribe();
      });
    } catch (e) {
      if (typeof errorCallback === 'function')
        errorCallback('Failed to terminate simulation');
    }
  };
};

export default terminateSimulation;
